export const SIDE_DRAWER_OPEN = "SIDE_DRAWER_OPEN";
export const SIDE_DRAWER_CLOSE = "SIDE_DRAWER_CLOSE";
